// utils/authOubli.js
// Éléments communs aux deux écrans « mot de passe oublié » (demande, puis nouveau mot de passe).

export const LONGUEUR_MIN_MOT_DE_PASSE = 8;

/** Langue d'interface à transmettre à WP pour les e-mails (fr, es ou en ; sinon WP choisit) */
export function langueInterface(i18n) {
  const langue = (i18n.language || '').slice(0, 2);
  return ['fr', 'es', 'en'].includes(langue) ? langue : undefined;
}

/** POST JSON vers l'App : renvoie { ok, code } ; une panne réseau devient WP_INDISPONIBLE */
export async function envoyerAuth(chemin, corps) {
  try {
    const rep = await fetch(chemin, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corps) });
    const data = await rep.json().catch(() => ({}));
    return { ok: rep.ok, code: data.code };
  } catch {
    return { ok: false, code: 'WP_INDISPONIBLE' };
  }
}

/** Message à afficher pour un code d'erreur renvoyé par l'App */
export function messageErreurOubli(t, code) {
  return ({
    WP_INDISPONIBLE: t('auth.serviceIndisponible'),
    TROP_DE_TENTATIVES: t('auth.tropDeTentatives'),
    JETON_INVALIDE: t('auth.lienInvalide'),
    MOT_DE_PASSE_TROP_COURT: t('auth.mdpTropCourt', { min: LONGUEUR_MIN_MOT_DE_PASSE }),
  })[code] || t('auth.erreurGenerique');
}
